import { styled } from '@pulse-web-ui/theme';

export const ToggleButton = styled.span`
  display: inline-block;
  margin-top: 16px;
`;
